import { render } from "./FloatingFaq.vue?vue&type=template&id=b0d1daa0&scoped=true&lang=pug"
import script from "./FloatingFaq.vue?vue&type=script&lang=js"
export * from "./FloatingFaq.vue?vue&type=script&lang=js"

import "./FloatingFaq.vue?vue&type=style&index=0&id=b0d1daa0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b0d1daa0"]])

export default __exports__